import { Provider } from '@angular/core';

import { SurveyDataHttpService } from './abstract';
import { SurveyDataHttpServiceImpl } from './survey-data-http.service';

export const SurveyDataHttpProvider: Provider = {
	provide: SurveyDataHttpService,
	useClass: SurveyDataHttpServiceImpl,
};
